import React from 'react'
import { ValidationResult, ErrorValidationIcon } from 'components/validation'
import { Button } from 'components/buttons'
import { localized } from 'decorators'

export const ValidationResultButton = localized(({ localize, onClick, buttonTitle, disabled, icon, isLoading, width, buttonColor = 'primary' }) => {
  return (
    <ValidationResult render={({ isValid }) =>
      <div style={{ display: 'inline', position: 'relative' }}>
        <Button
          color={buttonColor}
          onClick={onClick}
          isLoading={isLoading}
          icon={icon}
          width={width}
          disabled={disabled || !isValid}>{localize(buttonTitle || 'common.save')}</Button>
        <ErrorValidationIcon isValid={isValid} title={localize('common.formContainsValidationErrors')} backgroundColor='transparent' iconProps={{ style: { fontSize: 16 } }} />
      </div>
    } />
  )
})
